import { connect } from 'react-redux';
import { fetchR3DInterps } from '../../../api/interps/shared/interpActions';
import fetchInterps from '../../../api/interps/reading/interpActions';
import {
    fetchEnrollmentData,
    updateEnrollmentUrl,
} from '../../../api/enrollment/reading/enrollmentActions';
import { selectors } from '../../../root/reading/root';
import { fetchStudentResults } from '../../../api/results/reading/resultActions';
import fetchInterventions from '../../../api/interventions/interventionsActions';
import { fetchStudentGoalsReading } from '../../../api/studentGoals/reading/studentGoalsActions';
import { loadDemoData } from '../../../api/demoMode/reading/demoModeActions';

import { LICENSE } from '../../../constants/reading/CommonConstants';
import AppLayout from '../../../features/app/reading/AppLayout';
import ReadingApplicationConfigClient from '../../../api/clients/reading/ApplicationConfigClient';
import { fetchPdfAvailability as fetchPdfAvailabilityAction } from '../../../api/applicationConfig/shared/applicationConfigActions';

const mapStateToProps = state => ({
    location: selectors.getLocation(state),
    isEnrollmentDataExists: selectors.isEnrollmentDataExists(state),
    isDataFetched: selectors.isDataFetched(state),
    studentIds: selectors.getStudentIds(state),
    currentSchoolId: selectors.getSchoolId(state),
    currentClassId: selectors.getClassOrGroupId(state),
    currentDistrictId: selectors.getDistrictId(state),
    hasBurstLicense: selectors.hasAppLicenseByName(state, LICENSE.BURST),
    lrsTrackingInfo: selectors.getLrsTrackingInfo(state),
    licensingInfo: selectors.getLicensingInfo(state),
    isDemoModeOn: selectors.getIsDemoModeOn(state),
    demoClass: selectors.getDemoClass(state),
    isStaffConfigFetched: selectors.isStaffConfigFetched(state),
});

const mapDispatchToProps = dispatch => ({
    fetchEnrollmentData: isDemoModeOn =>
        isDemoModeOn
            ? () => {}
            : (districtId, schoolId, classId, period, burstGroupId) => {
                  dispatch(
                      fetchEnrollmentData(districtId, schoolId, classId, period, burstGroupId),
                  );
              },
    fetchStudentResults: isDemoModeOn =>
        isDemoModeOn
            ? () => {}
            : () => {
                  dispatch(fetchStudentResults());
              },
    fetchInterps: isDemoModeOn =>
        isDemoModeOn
            ? () => {}
            : () => {
                  dispatch(fetchInterps());
              },
    fetchStudentGoals: isDemoModeOn =>
        isDemoModeOn
            ? () => {}
            : () => {
                  dispatch(fetchStudentGoalsReading());
              },
    fetchPdfAvailability: isDemoModeOn =>
        isDemoModeOn
            ? () => {}
            : () => {
                  dispatch(fetchPdfAvailabilityAction(ReadingApplicationConfigClient));
              },
    fetchR3DInterps: isDemoModeOn =>
        isDemoModeOn
            ? () => {}
            : (baseUrl, applicationSid) => {
                  dispatch(fetchR3DInterps(baseUrl, applicationSid));
              },
    fetchInterventions: isDemoModeOn =>
        isDemoModeOn ? () => {} : hasBurstLicense => dispatch(fetchInterventions(hasBurstLicense)),
    updateEnrollmentUrl: () => dispatch(updateEnrollmentUrl()),
    loadDemoData: (isDemoModeOn, demoClass) =>
        isDemoModeOn ? () => dispatch(loadDemoData(demoClass)) : () => {},
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { isDemoModeOn, demoClass } = stateProps;
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        loadDemoData: dispatchProps.loadDemoData(isDemoModeOn, demoClass),
        fetchEnrollmentData: dispatchProps.fetchEnrollmentData(isDemoModeOn),
        fetchStudentResults: dispatchProps.fetchStudentResults(isDemoModeOn),
        fetchStudentGoals: dispatchProps.fetchStudentGoals(isDemoModeOn),
        fetchInterps: dispatchProps.fetchInterps(isDemoModeOn),
        fetchPdfAvailability: dispatchProps.fetchPdfAvailability(isDemoModeOn),
        fetchR3DInterps: dispatchProps.fetchR3DInterps(isDemoModeOn),
        fetchInterventions: dispatchProps.fetchInterventions(isDemoModeOn),
    };
};
export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AppLayout);
